import { render } from "./IreAreasValues.vue?vue&type=template&id=73b33352&ts=true"
import script from "./IreAreasValues.vue?vue&type=script&lang=ts"
export * from "./IreAreasValues.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__